import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { ServiceFee } from './ServiceFee';
/**
 * Configuration for specifying the service fee for a court system
 */
export class ServiceFeeConfiguration {
    /**
     * @param transcriptOrdering configuration that will be used to calculate the service fee for transcript orders
     * @param audioOrdering configuration that will be used to calculate the service fee for audio orders
     */
    constructor(transcriptOrdering, audioOrdering) {
        this.transcriptOrdering = transcriptOrdering;
        this.audioOrdering = audioOrdering;
    }
}
__decorate([
    Type(() => ServiceFee),
    __metadata("design:type", ServiceFee)
], ServiceFeeConfiguration.prototype, "audioOrdering", void 0);
__decorate([
    Type(() => ServiceFee),
    __metadata("design:type", ServiceFee
    /**
     * @param transcriptOrdering configuration that will be used to calculate the service fee for transcript orders
     * @param audioOrdering configuration that will be used to calculate the service fee for audio orders
     */
    )
], ServiceFeeConfiguration.prototype, "transcriptOrdering", void 0);
const DEFAULT_TRANSCRIPT_ORDERING_SERVICE_FEE_CONFIGURATION = new ServiceFee(false, 0, 0);
const DEFAULT_AUDIO_ORDERING_SERVICE_FEE_CONFIGURATION = new ServiceFee(false, 0, 0);
export const DEFAULT_SERVICE_FEE_CONFIGURATION = new ServiceFeeConfiguration(DEFAULT_TRANSCRIPT_ORDERING_SERVICE_FEE_CONFIGURATION, DEFAULT_AUDIO_ORDERING_SERVICE_FEE_CONFIGURATION);
